import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer-shell">
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h3>RedGoTrip</h3>
            <p>
              Founded in 2019, RedGoTrip Pvt. Ltd. helps travelers discover better holidays
              across India with curated packages, destination expertise and reliable booking support.
            </p>
            <div className="footer-badges">
              <span>Curated Trips</span>
              <span>Trusted Support</span>
              <span>India Tours</span>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/packages">Packages</Link></li>
              <li><Link to="/destinations">Destinations</Link></li>
              <li><Link to="/camping">Camping</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Support</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/awards">Awards & Recognition</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/booking/track">Track Booking</Link></li>
              <li><Link to="/wallet">Wallet</Link></li>
            </ul>
          </div>

          <div className="footer-section footer-contact">
            <h3>Contact Info</h3>
            <a href="tel:+919335444047" className="footer-contact-link">
              <i className="fas fa-phone-alt"></i>
              <span>+91 9335444047</span>
            </a>
            <a href="tel:+917895300727" className="footer-contact-link">
              <i className="fas fa-phone-alt"></i>
              <span>+91 7895300727</span>
            </a>
            <a href="mailto:info@redgotrips.com" className="footer-contact-link">
              <i className="fas fa-envelope"></i>
              <span>info@redgotrips.com</span>
            </a>
            <div className="footer-contact-link">
              <i className="fas fa-location-dot"></i>
              <span>India</span>
            </div>

            <div className="social-links">
              <a href="https://facebook.com/redgotrip" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com/redgotrip" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com/redgotrip" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-x-twitter"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 RedGoTrip Pvt. Ltd. All rights reserved.</p>
        </div>
      </footer>

      <a
        href="https://wa.me/919335444047"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span>WhatsApp</span>
      </a>
    </div>
  );
};

export default Footer;
